// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1MXpH","description":"PatientConsentPreview_description__pB6Nr"};